export default __webpack_public_path__ + "a4862abcbff10891396c3621a9d60004.svg";